export default {"src":"/_next/static/media/firefox-integration-icon.40e07a2f.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};